import React from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import { getIconUrl } from '.';
import { Link } from 'react-router-dom';
import TopicNavActiveItem from './TopicNavActiveItem';
import VideoStatsString from './VideoStatsString';


const TopicNav = ({ mobileUi, videoStats, baseUrl, topics, activeTopic, activeIssue }) => (
  <nav className="topic-tree-nav">
    {topics.map(topic => {
      const linkHref = urlJoin(baseUrl, topic.slug);
      if (mobileUi || activeTopic.slug === topic.slug) {
        return (
          <TopicNavActiveItem
            key={topic.slug}
            mobileUi={mobileUi}
            videoStats={videoStats}
            baseUrl={baseUrl}
            activeIssue={activeIssue}
            {...topic}
          />
        );
      }

      const { uid, name, slug, icon, color } = topic;
      const { iconReverse } = getIconUrl(icon);
      return (
        <div key={slug} className="topic-tree-nav-item">
          <div className="icon" style={{ backgroundColor: color }}>
            <img src={iconReverse} alt="" />
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            <Link to={linkHref}>
              <h5 className="heading-display text-uppercase mr-2">{name}</h5>
            </Link>
            <VideoStatsString videoStats={videoStats} uid={uid} />
          </div>
        </div>
      );
    })}
  </nav>
);

TopicNav.propTypes = {
  mobileUi: PropTypes.bool,
  videoStats: PropTypes.object,
  topics: PropTypes.arrayOf(PropTypes.object),
  activeTopic: PropTypes.object,
  activeIssue: PropTypes.object,
  activeMedia: PropTypes.object,
};

export default TopicNav;



// WEBPACK FOOTER //
// ./src/components/TopicTree/TopicNav.js